import anime from "animejs/lib/anime.es.js";

// Using clip-path animation
// On leave
// - [ ] swipe in left to right
// - [ ] Fade in logo
// On enter
// - [ ] Fade out logo
// - [ ] Swipe out left to right

const coverpage = document.querySelector(".cover-page");
const coverpageLogo = document.querySelector(".cover-page__logo");
const coverpageSubtext = document.querySelector(".cover-page__subtext");

const initial = "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)";
const show = "polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)";
const hide = "polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)";

const coverPageDuration = 800;

const coverpageTransitions = {
	showCover: function () {
		coverpage.style.display = "flex";

		return {
			targets: coverpage,
			webkitClipPath: [initial, show],
			clipPath: [initial, show],
			duration: coverPageDuration,
			easing: "easeInOutCubic",
		};
	},
	hideCover: function () {
		return {
			targets: coverpage,
			webkitClipPath: [show, hide],
			clipPath: [show, hide],
			duration: coverPageDuration,
			easing: "easeInOutCubic",
		};
	},
	showLogo: function () {
		return {
			targets: [coverpageLogo],
			opacity: [0, 1],
			translateY: [30, 0],
			duration: coverPageDuration / 2,
			easing: "easeInOutCubic",
		};
	},
	hideLogo: function () {
		return {
			targets: [coverpageLogo],
			opacity: [1, 0],
			translateY: [0, -30],
			duration: coverPageDuration / 2,
			easing: "easeInOutCubic",
		};
	},
	showSubtext: function () {
		return {
			targets: [coverpageSubtext],
			opacity: [0, 1],
			translateY: [30, 0],
			duration: coverPageDuration / 2,
			easing: "easeInOutCubic",
		};
	},
	hideSubtext: function () {
		return {
			targets: [coverpageSubtext],
			opacity: [1, 0],
			translateY: [0, -30],
			duration: coverPageDuration / 2,
			easing: "easeInOutCubic",
		};
	},
	beforeLeave: function (cb) {
		const tl = anime.timeline({
			duration: 1000,
		});
		tl.add(
			{
				...this.showCover(),
				complete: function () {
					cb();
				},
			},
			"-=200"
		);
	},
	afterEnter: function (cb) {
		const tl = anime.timeline({
			duration: 1000,
		});
		tl.add({
			...coverpageTransitions.hideCover(),
			complete: function () {
				cb();
			},
		});
	},
};

export default coverpageTransitions;
